(function() {
  var Router,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Router = App.loadClass('core::Router');

  exports.Router = (function(superClass) {
    extend(Router, superClass);

    function Router() {
      return Router.__super__.constructor.apply(this, arguments);
    }

    Router.prototype.prefix = 'BuyerLocation';

    Router.prototype.module_name = 'BuyerLocationRouter';

    Router.prototype.register = function() {
      this.module = angular.module(this.module_name, ['ui.router', 'ui.bootstrap']);
      this.service('grower::Angular/BuyerLocation/LocationService', ['$http']);
      this.controller('grower::Angular/BuyerLocation/LocationController', ['$scope', '$transitions', '$state', 'BuyerLocation.Services.LocationService']);
      this.controller('grower::Angular/BuyerLocation/PlacementController', ['$scope', '$transitions', '$state', 'BuyerLocation.Services.LocationService', '$timeout']);
      return this.controller('grower::Angular/BuyerLocation/IdentificationController', ['$scope', '$transitions', '$state', 'BuyerLocation.Services.LocationService']);
    };

    Router.prototype.registerRoutes = function($stateProvider) {
      return $stateProvider.state('grower.buyerlocation', {
        url: '/buyerlocation/:locationId?fpcResultId&step',
        templateUrl: 'backend/grower/buyer-location/sidebar',
        controller: [
          '$scope', '$state', 'BuyerLocation.Services.LocationService', '$http', function($scope, $state, $location, $http) {
            $scope.show_fullpage = false;
            $location.params = $state.params;
            $location.setAllLocations();
            if ($state.params.locationId) {
              return $http.post('backend/grower/buyer-location/load', {
                locationId: +$state.params.locationId
              }).then((function(_this) {
                return function(response) {
                  $location["new"] = response.data.data;
                  $location.createFeatureGroup();
                  return $state.go('grower.buyerlocation.place');
                };
              })(this));
            } else {
              $location.reset();
              return $state.go('grower.buyerlocation.locate');
            }
          }
        ]
      }).state('grower.buyerlocation.locate', {
        url: '/locate',
        views: {
          'sidebar-step@grower.buyerlocation': {
            templateUrl: 'backend/grower/buyer-location/locate',
            controller: 'BuyerLocation.Controllers.LocationController'
          }
        }
      }).state('grower.buyerlocation.place', {
        url: '/place',
        views: {
          'sidebar-step@grower.buyerlocation': {
            templateUrl: 'backend/grower/buyer-location/place',
            controller: 'BuyerLocation.Controllers.PlacementController'
          }
        }
      }).state('grower.buyerlocation.identify', {
        url: '/identify',
        views: {
          'sidebar-step@grower.buyerlocation': {
            templateUrl: 'backend/grower/buyer-location/identify',
            controller: 'BuyerLocation.Controllers.IdentificationController'
          }
        }
      });
    };

    return Router;

  })(Router);

}).call(this);
